import { PriceNumeric_Schema } from "@/services/prices/priceSchema";
import { z } from "zod";

export enum ShippingMethodUid {
  ZasilkovnaPickupPoint = "zasilkovna-pickup-point",
  ZasilkovnaAddressDelivery = "zasilkovna-address-delivery",
  LocalPickup = "local-pickup",
  BalikovnaBox = "balikovna-box",
  BalikovnaHome = "balikovna-home",
}

export const ShippingMethodUid_Schema = z.enum(ShippingMethodUid);

export const ShippingMethodId_Schema = z.number().int().positive();

export const ShippingMethod_Schema = z.object({
  id: ShippingMethodId_Schema,
  name: z.string(),
  description: z.string(),
  price: PriceNumeric_Schema,
  uid: ShippingMethodUid_Schema,
});
